/* @flow */

export const getMetaNodeValue = (name: string): string | null => {
  const elt = document.querySelector(`meta[name="${name}"]`);
  if (elt instanceof HTMLMetaElement) return elt.content;
  return null;
};
